<template>
  <UApp :toaster="toaster">
    <!-- 背景用 design 的 --bg(#07080c)，与 .ft-scope 内容区一致，避免色差缝 -->
    <div class="flex flex-col bg-[#07080c] min-h-screen custom-scroll">
      <!-- 顶部 Header + Banner（与 default-new 一致） -->
      <div class="sticky top-0 z-9999">
        <TopBanners />
        <FotoHeader />
      </div>

      <!-- 主体：全宽，无左侧工具导航（free-tools 落地页按 design 全宽，内容靠 .wrap 居中） -->
      <div class="flex-1 flex flex-col">
        <NuxtPage class="flex-1" />
      </div>

      <!-- 底部（全宽，不预留侧栏宽度） -->
      <FotoFooter v-if="showFooter" />
      <div v-else class="h-5"></div>
    </div>

    <!-- 认证 / 积分 / 预览 模态框（与 default-new 一致，保证 header 功能可用） -->
    <SignUpModal
      :is-open="isSignUpModalOpen"
      @close="closeSignUpModal"
      @switch-to-sign-in="switchToSignIn"
    />
    <SignInModal
      :is-open="isSignInModalOpen"
      @close="closeSignInModal"
      @switch-to-sign-up="switchToSignUp"
    />
    <NotEnoughCredits
      v-model:is-open="isCreditsModalOpen"
      :required-credits="requiredCredits"
      :current-balance="currentCredits"
      :show-required-credits="showRequiredCredits"
      :view="creditsModalView"
      @close="closeCreditsModal"
    />
    <GlobalImagePreview
      :is-open="isImagePreviewOpen"
      :src="imagePreviewSrc"
      :compare="imagePreviewCompare"
      @close="closeImagePreview"
    />
  </UApp>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import TopBanners from "@/components/TopBanners.vue";
import defaultCssUrl from "~/assets/styles/new-index.css?url";
import FotoHeader from "@/components/FotoHeaderNew.vue";
import FotoFooter from "@/components/FotoFooterNew.vue";
import SignUpModal from "@/components/loginModal/SignUpModal.vue";
import SignInModal from "@/components/loginModal/SignInModal.vue";
import NotEnoughCredits from "@/components/newModal/NotEnoughCredits.vue";
import GlobalImagePreview from "@/components/newModal/GlobalImagePreview.vue";

const toaster = { position: "top-right" };
const route = useRoute();
const showFooter = computed(() => route.meta.showFooter ?? true);

useHead({
  link: [
    {
      rel: "stylesheet",
      href: defaultCssUrl,
      crossorigin: "anonymous",
      key: "layout-style",
    },
    {
      rel: "preload",
      href: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6439841372484008",
      as: "script",
      crossorigin: "anonymous",
      key: "adsbygoogle-preload",
    },
  ],
  htmlAttrs: { class: "dark" }, // 确保 SSR 也加上 dark
});

defineOptions({
  name: "free-tools-layout",
});

const store = useStore();
const userInfo = computed(() => store.state.user.userInfo);
const currentCredits = computed(() => userInfo.value?.credits_sum || 0);

// 与 default-new 相同的模态框逻辑（header 的登录/积分入口依赖）
const {
  isSignInModalOpen,
  isSignUpModalOpen,
  closeSignInModal,
  closeSignUpModal,
  switchToSignIn,
  switchToSignUp,
} = useAuthModals();

const {
  isCreditsModalOpen,
  requiredCredits,
  showRequiredCredits,
  creditsModalView,
  closeCreditsModal,
} = useCreditsModal();

const {
  isImagePreviewOpen,
  imagePreviewSrc,
  imagePreviewCompare,
  closeImagePreview,
} = useImagePreview();
</script>
